@if (cardImageContent) {
  <div class="card-with-image-container">
    <div class="image-container">
      <img [src]="'/public/assets/images/' + cardImageContent.image" [alt]="cardImageContent.image" />
    </div>
    <div class="content-container">
      <ds-chip [text]="cardImageContent.chipText"></ds-chip>
      <h2>{{ cardImageContent.title }}</h2>
      <p>{{ cardImageContent.subtitle }}</p>
      <div class="additional-content-from-parent">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}

